import React, { Component } from 'react';
import { connect } from 'react-redux';
import { gridColumns } from '../../../constants';
import { securitiesActions as actions, gridActions } from '../../../actions';
import { classnames } from '../../../styles/classnames';
import { formatUtils } from '../../../utils';
import { ChangePxTalk } from '../../common';


class PxTalk extends Component {
    shouldComponentUpdate = nextProps =>
        this.props.hasFocus !== nextProps.hasFocus
        || this.props.editing !== nextProps.editing
        || this.props.value !== nextProps.value

    render = () => {
        const { value, hasFocus, editing, dispatch } = this.props;

        const cssClasses = classnames({
            'cell-pxTalk': true,
            'has-focus': hasFocus
        });

        return (
            <td
                className={cssClasses}
                onClick={this.handleClick}
            >
                <div className="cell-item">
                    <span className="cell-item-text"><span className="pseudo-link">{formatUtils.formatPxTalk(value)}</span></span>
                    {hasFocus && <input autoFocus type="text" className="invisible" />}
                    {hasFocus && !editing && <input autoFocus type="text" className="invisible" />}
                    {
                        editing &&
                        <ChangePxTalk
                            saveButtonText="Apply"
                            onCancel={this.handleEditCancel}
                            onSave={() => dispatch(actions.savePxTalks())}
                        />
                    }
                </div>
            </td>
        );
    }

    handleClick = () => {
        const { editing, hasFocus, onClick } = this.props;
        if (!editing) {
            onClick(gridColumns.pxTalks.name, hasFocus);
        }
    }

    handleEditCancel = () => {
        const { dispatch } = this.props;

        dispatch(gridActions.blockInput(false));
        dispatch(gridActions.cancelEdit());
    }
}

const mapStateToProps = () => ({});

const connectedPxTalk = connect(mapStateToProps)(PxTalk);
export { connectedPxTalk as PxTalk }; 
